/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function () {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	window.sessionStorage.removeItem('page_current_category');
	// init pagination links on page load
	initPagination();


	// This is used to load dynamic posts on div.grid-articles-ajax-container
	// when a category link is clicked
	jQuery('.cat-list_item').on('click', function () {
		
		jQuery('.cat-list_item').removeClass('active');
		jQuery(this).addClass('active');
		jQuery('.grid-articles-ajax-container').fadeTo("fast", 0);

		jQuery('.pagination').fadeTo("fast", 0);

		window.sessionStorage.setItem("page_current_category", jQuery(this).data('slug'));


		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'filter_articles',
				category: jQuery(this).data('slug'),
				paged: "1",
			},
			success: function (res) {
				jQuery('.grid-articles-ajax-container').html(res);
				jQuery('.grid-articles-ajax-container').fadeTo("slow", 1);
			}
		})
		// Load pagination
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'filter_articles_pagination',
				category: jQuery(this).data('slug'),
				paged: "1",
			},
			success: function (res) {
				jQuery('.pagination').html(res.content);
				jQuery('.pagination').fadeTo("slow", 1);
				initPagination({
					current_page:1,
					total_pages:res.total_pages
				});
			}
		})
	});


	function initPagination(args) {
		args = args || {}
		// Replace the Wordpress' default current page number from <span> to <a>
		jQuery("ul.pagination_list li.page_li").find("span.page-numbers").replaceWith(function (i, content) {
			let url = window.location.protocol + '//' + window.location.host + '/page/' + content + '/';
			return '<a class="page-numbers current" href="' + url + '">' + content + '</a>';
		});

		// add click event on all page links
		var element = document.getElementsByClassName('page-numbers');
		for (let i = 0; i < element.length; i++) {
			element[i].addEventListener("click", paginateAjax, false);
		}
		let prevnextEl = jQuery('.paginate-prev-next');
		if (args && typeof args.total_pages != 'undefined') {
			prevnextEl.data('total-pages', args.total_pages);
			if (args.total_pages == 1) {				
				jQuery('.prev,.next', prevnextEl).addClass('hidden');
			} else {
				jQuery('.next',prevnextEl).removeClass('hidden');
			}
		}
		if (args && typeof args.current_page != 'undefined') {
			prevnextEl.data('current-page', args.current_page);
			if (args.current_page == 1) {				
				jQuery('.prev', prevnextEl).addClass('hidden');
			} else {
				jQuery('.prev',prevnextEl).removeClass('hidden');
			}
		}	
		
		jQuery('.paginate-prev-next li a').off('click').on('click', function () {
			let el = jQuery(this);
			let parent = el.parents('.paginate-prev-next');
			let total_pages = parent.data('total-pages');
			let per_page = parent.data('posts-per-page'); 
			let current_page = parseInt(parent.data('current-page'));
			if (total_pages == 1) {
				
				jQuery('.prev,.next', parent).addClass('hidden');
				return;
			}
			if (el.hasClass('next')) {
				current_page++;
			} else {
				current_page--;
			}
			parent.data('current-page',current_page);			
			parent.data('total-pages', total_pages);
			// console.log('total:' + total_pages,'per page' + per_page,'current' + current_page);
			loadNewPagination({
				action: 'filter_articles',
				category: window.sessionStorage.getItem("page_current_category"),
				paged: current_page,
				posts_per_page: per_page
			}).then(function (res) {
				jQuery('.grid-articles-ajax-container').html(res);
				jQuery('.grid-articles-ajax-container').fadeTo("slow", 1);
				if (current_page > 1) {
					jQuery('.prev', parent).removeClass('hidden');
				} else {
					jQuery('.prev', parent).addClass('hidden');
				}
				if (current_page == total_pages) {
					jQuery('.next', parent).addClass('hidden');
				} else {
					jQuery('.next', parent).removeClass('hidden');

				}
			});
		});
	}


	function paginateAjax(event) {

		event.preventDefault();
		jQuery('.grid-articles-ajax-container').fadeTo("fast", 0);

		let parentID = jQuery(event.target).parent().attr('id');
		let current_element = jQuery("li#" + parentID);

		let per_page = current_element.parents('.pagination').data('posts-per-page');
		loadNewPagination({
			action: 'filter_articles',
			category: window.sessionStorage.getItem("page_current_category"),
			paged: jQuery(event.target).text(),
			posts_per_page: per_page
		}).then(function (res) {
			jQuery('.grid-articles-ajax-container').html(res);
			jQuery('.grid-articles-ajax-container').fadeTo("slow", 1);

			jQuery("ul.pagination_list li.page_li").find(".current").removeClass("current");
			current_element.children().addClass("current");
		});

	}

	function loadNewPagination(args) {
		return jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: args
		})
	}

});